const LANGUAGE_CODES = [
  { text: 'English', value: 'en' },
  { text: 'Indonesian', value: 'id' },
  { text: 'Vietnamese', value: 'vi' },
];

export default LANGUAGE_CODES;



// WEBPACK FOOTER //
// ./src/constants/languages.js